/**
 * Wallet utilities — use with Wagmi + RainbowKit.
 * - Address/connection: use useAccount() from 'wagmi' in components.
 * - On-chain transactions: use getEthersSignerFromWalletClient(walletClient) with useWalletClient().
 */

import { BrowserProvider } from 'ethers'

/**
 * Get ethers v6 Signer from a Wagmi WalletClient (e.g. from useWalletClient()).
 * Use this when the user may be connected via WalletConnect (mobile).
 */
export async function getEthersSignerFromWalletClient(walletClient) {
  if (!walletClient?.request) return null
  const provider = new BrowserProvider({
    request: (args) => walletClient.request(args),
  })
  return provider.getSigner()
}

/**
 * Format address for display.
 *
 * TODO: this duplicates utils/formatters.js#formatAddress (minor: empty-input fallback differs).
 * Consolidate in a follow-up commit.
 */
export function formatAddress(address) {
  if (!address) return ''
  return `${address.slice(0, 6)}...${address.slice(-4)}`
}
